import './App.css';
import { useNavigate } from 'react-router-dom';
import DashboardHeader from './dashboardheader.js'
import VerticalNavigation from './VerticalNavigation.js'

function ReviewQueue() {
  const navigate = useNavigate();

  return (
    <div className="App min-h-screen">
      <div className="dashboard-wrapper flex flex-col min-h-screen">
        <div className="dashboard-header flex w-full max-h-24 h-14">
          <DashboardHeader />
        </div>
        <div className="w-full flex flex-wrap min-h-screen">
          <div className="dashboard-left-sidebar flex-none w-48 relative">
            <VerticalNavigation />
          </div>
          <div className="dashboard-right-main border-1 flex-auto p-6">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-2xl font-bold text-left">Review Queue</h2>
              <button
                onClick={() => navigate('/reviews')}
                className="px-3 py-1 bg-gray-600 text-white font-medium rounded-lg hover:bg-gray-700 transition-colors duration-200"
              >
                Exit Queue
              </button>
            </div>
            <div className="flex justify-between items-center mb-6">
              <p className="text-xs">This is review 4 of 7</p>
            </div>
            <div className="mb-6">
              <div className="overflow-x-auto">
                <table className="min-w-full bg-white border border-gray-200 rounded-lg shadow-sm text-sm">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase border-b">Name</th>
                      <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase border-b">Email</th>
                      <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase border-b">Location</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    <tr className="hover:bg-gray-50">
                      <td className="px-3 py-2 whitespace-nowrap text-left text-sm font-medium text-gray-900">Sarah Johnson</td>
                      <td className="px-3 py-2 whitespace-nowrap text-left text-sm text-gray-600">sarah.johnson@example.com</td>
                      <td className="px-3 py-2 whitespace-nowrap text-left text-sm text-gray-600">SomeLocationPlace</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="mb-6">
              <div className="overflow-x-auto">
                <table className="min-w-full bg-white border border-gray-200 rounded-lg shadow-sm text-sm">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase border-b">Gender</th>
                      <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase border-b">Age</th>
                      <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase border-b">Height (ft)</th>
                      <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase border-b">Height (in)</th>
                      <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase border-b">Weight (lbs)</th>
                      <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase border-b">Abdomen</th>
                      <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase border-b">Biceps</th>
                      <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase border-b">Thigh</th>
                      <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase border-b">Calf</th>
                      <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase border-b">Hip</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    <tr className="hover:bg-gray-50">
                      <td className="px-3 py-2 whitespace-nowrap text-left text-sm text-gray-600">Female</td>
                      <td className="px-3 py-2 whitespace-nowrap text-left text-sm text-gray-600">32</td>
                      <td className="px-3 py-2 whitespace-nowrap text-left text-sm text-gray-600">5</td>
                      <td className="px-3 py-2 whitespace-nowrap text-left text-sm text-gray-600">6</td>
                      <td className="px-3 py-2 whitespace-nowrap text-left text-sm text-gray-600">145</td>
                      <td className="px-3 py-2 whitespace-nowrap text-left text-sm text-gray-600">32"</td>
                      <td className="px-3 py-2 whitespace-nowrap text-left text-sm text-gray-600">11"</td>
                      <td className="px-3 py-2 whitespace-nowrap text-left text-sm text-gray-600">21"</td>
                      <td className="px-3 py-2 whitespace-nowrap text-left text-sm text-gray-600">14"</td>
                      <td className="px-3 py-2 whitespace-nowrap text-left text-sm text-gray-600">38"</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="mb-6">
              <div className="overflow-x-auto">
                <table className="min-w-full bg-white border border-gray-200 rounded-lg shadow-sm text-sm">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase border-b">Cardio Days/Week</th>
                      <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase border-b">Cardio Mins/Session</th>
                      <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase border-b">Strength Days/Week</th>
                      <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase border-b">Strength Mins/Session</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    <tr className="hover:bg-gray-50">
                      <td className="px-3 py-2 whitespace-nowrap text-left text-sm text-gray-600">3</td>
                      <td className="px-3 py-2 whitespace-nowrap text-left text-sm text-gray-600">30</td>
                      <td className="px-3 py-2 whitespace-nowrap text-left text-sm text-gray-600">4</td>
                      <td className="px-3 py-2 whitespace-nowrap text-left text-sm text-gray-600">45</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="mb-6">
              <div className="overflow-x-auto">
                <table className="min-w-full bg-white border border-gray-200 rounded-lg shadow-sm text-sm">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase border-b">Meals/Day</th>
                      <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase border-b">Snacks/Day</th>
                      <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase border-b">First Meal</th>
                      <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase border-b">Last Meal</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    <tr className="hover:bg-gray-50">
                      <td className="px-3 py-2 whitespace-nowrap text-left text-sm text-gray-600">3</td>
                      <td className="px-3 py-2 whitespace-nowrap text-left text-sm text-gray-600">2</td>
                      <td className="px-3 py-2 whitespace-nowrap text-left text-sm text-gray-600">0730</td>
                      <td className="px-3 py-2 whitespace-nowrap text-left text-sm text-gray-600">1900</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="mb-6">
              <div className="overflow-x-auto">
                <table className="min-w-full bg-white border border-gray-200 rounded-lg shadow-sm text-sm">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase border-b">Diabetic</th>
                      <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase border-b">Bariatric Surgery</th>
                      <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase border-b">Lactating</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    <tr className="hover:bg-gray-50">
                      <td className="px-3 py-2 whitespace-nowrap text-left text-sm text-gray-600">No</td>
                      <td className="px-3 py-2 whitespace-nowrap text-left text-sm text-gray-600">No</td>
                      <td className="px-3 py-2 whitespace-nowrap text-left text-sm text-gray-600">No</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="mb-6">
              <h3 className="text-lg font-semibold text-gray-700 mb-3">Recommendations</h3>
              <textarea
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                rows="6"
                placeholder="Enter recommendations..."
              />
            </div>

            <div className="mb-6">
              <h3 className="text-lg font-semibold text-gray-700 mb-3">Additional Notes</h3>
              <textarea
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                rows="6"
                placeholder="Enter recommendations..."
              />
            </div>

            <div className="flex justify-end">
              <button
                className="px-6 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors duration-200"
              >
                Submit Review and Go to Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReviewQueue;
